import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import liffService from '../services/liff';

const PARAM_NAME = 'store-id';

/**
 * React Router 内に置く URL ガード。
 *
 * 目的: LIFFブラウザの「リンクをコピー」「シェア」は、コピー時点の URL を元に
 * パーマネントリンク (https://liff.line.me/{liffId}/{path}?{query}) を生成する。
 * URL バーに store-id が残っていないと、共有先で「store-id が無い」エラーになる。
 *
 * 実装: 全ての navigate / Link / Navigate を書き換える代わりに、ここで location
 * 変化を監視し、store-id が抜けていれば replace で付け直す（履歴は汚さない）。
 */
const PreserveStoreIdParam: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const storeId = liffService.getStoreId();
    if (!storeId) return;

    const params = new URLSearchParams(location.search);
    if (params.get(PARAM_NAME) === storeId) return;

    params.set(PARAM_NAME, storeId);
    navigate(
      {
        pathname: location.pathname,
        search: `?${params.toString()}`,
        hash: location.hash,
      },
      { replace: true, state: location.state }
    );
  }, [location, navigate]);

  return null;
};

export default PreserveStoreIdParam;
